import {
  Control,
  Controller,
  FieldPath,
  FieldValues,
  RegisterOptions,
} from "react-hook-form";

export type FormInputProps = {
  control: Control<any>;
  name: string;
  rules?: Omit<
    RegisterOptions<FieldValues, FieldPath<FieldValues>>,
    "valueAsNumber" | "valueAsDate" | "setValueAs"
  >;
  label: string;
  type?: string | undefined;
  inputProps?: any;
  className: string;
  options?: Array<{ id: number | string; name: string }>;
};

function FormInput(props: FormInputProps) {
  const {
    control,
    name,
    rules,
    label,
    type,
    inputProps,
    className,
    options = [],
  } = props;
  const {
    className: inputClass = "",
    showLabel = true,
    showEmptyOption = true,
    showSelectOption = false,
  } = inputProps ?? {};

  return (
    // @ts-ignore
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState }) => (
        <div className={className}>
          {showLabel && label && type !== "checkbox" ? (
            <label
              className={`gray_light fz15 regular_font ${
                fieldState.error ? "text-danger" : ""
              }`}
            >
              {label}
            </label>
          ) : null}
          {type === "select" ? (
            <select
              {...field}
              value={field.value}
              {...inputProps}
              className={`${
                inputClass ? inputClass : ""
              } form-control custom_form_control p-0 ${
                fieldState.error ? "is-invalid" : ""
              }`}
            >
              {showSelectOption ? (
                <option value={""}>Select {label}</option>
              ) : showEmptyOption ? (
                <option style={{ display: "none" }} />
              ) : null}
              {options?.map((option) => (
                <option key={option.id} value={option.id}>
                  {option.name}
                </option>
              ))}
            </select>
          ) : type === "textarea" ? (
            <textarea
              {...field}
              {...inputProps}
              className={`${
                inputClass ? inputClass : ""
              } form-control custom_form_control ${
                fieldState.error ? "is-invalid" : ""
              }`}
            ></textarea>
          ) : type === "checkbox" ? (
            <>
              <input
                {...field}
                type={type}
                {...inputProps}
                className={`${inputClass ? inputClass : ""} mr-1 mt-3 ${
                  fieldState.error ? "is-invalid" : ""
                }`}
                name={label.replaceAll(" ", "_")}
              />
              <label
                htmlFor={label.replaceAll(" ", "_")}
                className={`gray_light fz15 regular_font ${
                  fieldState.error ? "text-danger" : ""
                }`}
              >
                {label}
              </label>
            </>
          ) : (
            <input
              {...field}
              type={type}
              {...inputProps}
              className={`${
                inputClass ? inputClass : ""
              } form-control custom_form_control ${
                fieldState.error ? "is-invalid" : ""
              }`}
            />
          )}

          {fieldState.error ? (
            <small className="text-danger">{fieldState.error?.message}</small>
          ) : null}
        </div>
      )}
    />
  );
}

export default FormInput;
